
import React from 'react';
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Card, CardContent } from "@/components/ui/card";

interface EmailTemplateEditorProps {
  initialHtml?: string;
  initialText?: string;
  onHtmlChange: (html: string) => void;
  onTextChange: (text: string) => void;
}

export const EmailTemplateEditor: React.FC<EmailTemplateEditorProps> = ({
  initialHtml = '',
  initialText = '',
  onHtmlChange,
  onTextChange
}) => {
  const insertTemplate = (template: string) => {
    onHtmlChange(initialHtml + template);
  };

  return (
    <Card>
      <CardContent className="space-y-4 pt-4">
        <div>
          <Label>HTML Content</Label>
          <Textarea
            value={initialHtml}
            onChange={(e) => onHtmlChange(e.target.value)}
            className="h-64 font-mono"
            placeholder="Enter your HTML email template here..."
          />
        </div>

        <div>
          <Label>Quick Templates</Label>
          <div className="flex space-x-2 mb-2">
            <Button 
              variant="outline" 
              size="sm" 
              type="button"
              onClick={() => insertTemplate('<div style="text-align: center;"><img src="/img/nationcard-light.png" alt="NationCard Logo" style="width: 160px; height: auto; display: block; margin: 0 auto;"/></div>')}
            >
              Logo Header
            </Button>
            <Button 
              variant="outline" 
              size="sm" 
              type="button"
              onClick={() => insertTemplate('<p style="color: #666;">Best regards,<br>The NationCard Team</p>')}
            >
              Signature
            </Button>
          </div>
        </div>

        <div>
          <Label>Plain Text Version</Label>
          <Textarea
            value={initialText}
            onChange={(e) => onTextChange(e.target.value)}
            className="h-32"
            placeholder="Enter a plain text alternative..."
          />
        </div>
      </CardContent>
    </Card>
  );
};

export default EmailTemplateEditor;
